<template>
  <button class="t-button" @click="onClick">
    <slot></slot>
  </button>
</template>
<script>
export default {
  name: 'TButton',
  methods: {
    onClick() {
      this.$emit('click')
    }
  }
}
</script>
<style lang="scss" scoped>
button {
  all: unset;
}
.t-button {
  width: 254px;
  height: 50px;
  background-image: url('../../assets/icon/btn_bg.png');
  background-size: 100% 100%;
  text-align: center;
  font-size: 16px;
  color: #ffffff;
  cursor: pointer;
}
</style>
